import React from "react";

import { Controller } from "react-hook-form";

import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";

import dayjs from "dayjs";

const FormDatePicker = ({
                            name,
                            label,
                            control,
                            setValue,
                            selectorValue,
                            width,
                            variant = "filled",
                            disabled = false
                        }) => {

    /*
     * Force React Hook Form to use the actual record value
     * when this field mounts/reopens or when the record changes.
     *
     * This eliminates an unsubmitted value left over from a
     * previous Cancel.
     */
    React.useEffect(() => {

        if (setValue && name) {
            setValue(
                name,
                selectorValue ?? null,
                {
                    shouldDirty: false,
                    shouldTouch: false,
                    shouldValidate: false
                }
            );
        }

    }, [name, selectorValue, setValue]);


    return (
        <LocalizationProvider dateAdapter={AdapterDayjs}>

            <Controller
                name={name}
                control={control}
                defaultValue={selectorValue ?? null}

                render={({ field, fieldState }) => (

                    <DatePicker

                        label={label}

                        value={
                            field.value
                                ? dayjs(field.value)
                                : null
                        }

                        onChange={(newValue) => {

                            field.onChange(
                                newValue
                                    ? newValue.format("YYYY-MM-DD")
                                    : null
                            );

                        }}

                        format="YYYY-MM-DD"

                        disabled={disabled}

                        slotProps={{

                            textField: {

                                variant: variant,

                                error: !!fieldState.error,

                                helperText:
                                fieldState.error?.message,

                                sx: {
                                    width: width,
                                    pr: 5
                                }
                            }
                        }}
                    />
                )}
            />

        </LocalizationProvider>
    );
};

export default FormDatePicker;
// import React from "react";
//
// import { Controller } from "react-hook-form";
//
// import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
// import { DatePicker } from "@mui/x-date-pickers/DatePicker";
// import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
//
// import dayjs from "dayjs";
//
// const FormDatePicker = ({
//                             name,
//                             label,
//                             control,
//                             width,
//                             variant = "filled",
//                             disabled = false
//                         }) => {
//
//     return (
//         <LocalizationProvider dateAdapter={AdapterDayjs}>
//
//             <Controller
//                 name={name}
//                 control={control}
//                 defaultValue={null}
//                 width={width}
//
//                 render={({ field, fieldState }) => (
//
//                     <DatePicker
//
//                         label={label}
//
//                         value={
//                             field.value
//                                 ? dayjs(field.value)
//                                 : null
//                         }
//
//                         onChange={(newValue) => {
//
//                             field.onChange(
//                                 newValue
//                                     ? newValue.format("YYYY-MM-DD")
//                                     : null
//                             );
//
//                         }}
//
//                         disabled={disabled}
//
//                         slotProps={{
//
//                             textField: {
//
//                                 variant: variant,
//
//                                 error: !!fieldState.error,
//
//                                 helperText:
//                                 fieldState.error?.message,
//
//                                 sx: {
//                                     width: width,
//                                     pr: 5
//                                 }
//                             }
//                         }}
//                     />
//                 )}
//             />
//
//         </LocalizationProvider>
//     );
// };
//
// export default FormDatePicker;